export default "__VITE_PUBLIC_ASSET__7542b0a3__"